import React from 'react';
import { TouchableOpacity } from 'react-native';
import { Factory, HStack, Icon, Modal, Text } from 'native-base';
import { useNavigation } from '@react-navigation/native';
import { AntDesign } from '@expo/vector-icons';

import { useAuth } from '@contexts/Auth';
import {
  useManageCustomersResponsiveOverlayError
} from '@hooks/useManageCustomersResponsiveOverlayError';

const TouchableOpacityFactory = Factory(TouchableOpacity);

export function Web() {
  const navigation = useNavigation();
  const { isOpen, onClose } = useManageCustomersResponsiveOverlayError();
  const { user } = useAuth();
  const industry = user?.getNameIndustryStore();

  function handleUpdateOrder() {
    onClose();
    navigation.navigate('SummaryOrder', { industry: industry });
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Modal.Content maxWidth="504px" px={6} pb={6}>
        <Modal.CloseButton _icon={{
          size: 4,
          color: 'primary.600'
        }}/>

        <Modal.Header pl={0}>
          <HStack alignItems='center'>
            <Icon
              as={AntDesign}
              name='warning'
              color='red.500'
              size={8}
              mr={4}
            />

            <Text color='red.500' fontSize='lg' fontFamily='subheading'>
              Remova o(s) cupom(ns)
            </Text>
          </HStack>
        </Modal.Header>

        <Modal.Body px={0} pb={0} mb={12}>
          <Text fontSize='md' color='muted.800'>
            Para prosseguir com a operação de gerenciamento de clientes,{"\n"}
            é necessário remover o(s) cupom(ns) aplicados no pedido.
          </Text>
        </Modal.Body>

        <TouchableOpacityFactory
          testID='manage-customers-error-web_update-order'
          bg='primary.600'
          h={12}
          rounded='sm'
          p={4}
          mb={4}
          alignItems='center'
          justifyContent='center'
          _dark={{
            opacity: 0.8,
          }}
          onPress={handleUpdateOrder}
        >
          <Text fontSize='sm' fontFamily='subheading' color='muted.100'>
            Alterar o pedido
          </Text>
        </TouchableOpacityFactory>

        <TouchableOpacityFactory
          testID='manage-customers-error-web_cancel'
          h={12}
          rounded='sm'
          p={4}
          alignItems='center'
          justifyContent='center'
          _dark={{
            opacity: 0.7,
          }}
          onPress={onClose}
        >
          <Text fontSize='sm' fontFamily='subheading' color='primary.600'>
            Cancelar
          </Text>
        </TouchableOpacityFactory>
      </Modal.Content>
    </Modal>
  );
}